import API from "../../../Api/API"

const api = new API()

export const submitRatingApi = (data) =>
  api.post('/ratings', data)

export const fetchRatingsApi = (params = {}) => {
  const qs = new URLSearchParams()
  Object.entries(params).forEach(([k, v]) => { if (v != null && v !== '') qs.set(k, String(v)) })
  const str = qs.toString()
  return api.get(`/ratings${str ? `?${str}` : ''}`)
}

export const fetchTrustScoreApi = (userId) =>
  api.get(`/ratings/trust_score?user_id=${userId}`)
